<div>
  <div bsModal #cloneModal="bs-modal" class="modal" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name">
    <div class="modal-dialog modal-md">
      <div class="modal-content">
        <div class="modal-header" style="border-bottom: 0 !important; padding-bottom: 0">
          <div class="message">Choose items you want to clone</div>
          <button type="button" class="close pull-right" aria-label="Close" (click)="cancel()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="content">
            <ul class="options">
              <a
                href=""
                (click)="toggleSelectAll($event)"
                [innerHTML]="items.length === selectedItems.length ? 'Deselect All' : 'Select All'"></a>
              <p *ngIf="!this.isValid && isCustomVersion" style="color: red">*Customization cannot be applied</p>
              <p *ngIf="!this.isValid && !isCustomVersion" style="color: red">
                *Customizations may break conditional logic and result in an invalid version.
              </p>
              <li *ngFor="let item of items">
                <input
                  type="checkbox"
                  [value]="item"
                  [ngModel]="selectedItems.includes(item)"
                  (ngModelChange)="updateSelectedItems(item)" />
                {{ item.name }}
                <ul class="sections">
                  <li *ngFor="let section of item.sections">
                    <input
                      type="checkbox"
                      [value]="section"
                      [ngModel]="selectedSections.includes(section)"
                      (ngModelChange)="updateSelectedSections(section, item)" />
                    {{ section.name }}
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          <div style="text-align: center">
            <button
              type="button"
              class="btn btn-primary aru"
              [disabled]="selectedItems.length === 0 || !this.cloneEnabled"
              (click)="clone()">
              Clone
            </button>
            <button type="button" class="btn btn-default aru" (click)="cancel()">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div bsModal #validationModal="bs-modal" class="modal" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header" style="border-bottom: 0 !important">
        <div class="message">The version '{{ this.version.name }}' has been cloned but it's invalid</div>
        <button type="button" class="close pull-right" aria-label="Close" (click)="cancel()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" [perfectScrollbar] style="max-height: 500px">
        <div class="message-html">
          Issues that need to be fixed <span style="color: #dc3e3e">({{ invalidQuestions.length }})</span>
        </div>
        <div class="content" *ngIf="invalidQuestions">
          <div *ngFor="let problem of invalidQuestions" class="issue-card">
            <div class="warning-badge">
              <i class="fa fa-warning"></i>
            </div>
            <div class="issue-content">
              <span class="title">{{ problem.questionText }}</span>
              <span class="description">Fix {{ problem.type }} conditional logic</span>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary aru" (click)="fixValidationConditions()">Fix the issues</button>
        <button type="button" class="btn btn-default aru" (click)="cancel()" style="color: #dc3e3e">Cancel</button>
      </div>
    </div>
  </div>
</div>
